import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { CouponType } from "../constants";

const Coupons = () => {
  const [userCoupons, setUserCoupons] = useState([]);
  const [loading, setLoading] = useState(false);
  const { token, userId } = useSelector((state) => state.auth);
  const { userDetail } = useSelector((state) => state.userDetail);
  useEffect(() => {
    window.scrollTo(0, 0);
    fetchAllCoupons();
  }, []);

  const fetchAllCoupons = async () => {
    setLoading(true);
    if (!token) {
      const loggedoutRes = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/coupons/user/all`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      const loggedoutData = await loggedoutRes.json();
      setUserCoupons(loggedoutData.responseObject || []);
      setLoading(false);
    } else {
      try {
        // Fetch user-specific coupons
        const userRes = await fetch(
          `${process.env.REACT_APP_BACKEND_URL}/api/coupons/user`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        const userData = await userRes.json();
        setUserCoupons(userData.responseObject || []);
      } catch (error) {
        // console.log("fetch coupons error", error);
      } finally {
        setLoading(false);
      }
    }
  };

  const isCouponUsed = (coupon) => {
    // For REGISTERED_SINGLE_USE coupons, check if current user has used it
    // if (coupon.couponType === CouponType.REGISTERED_SINGLE_USE) {
    //   return coupon.usedBy?.some((id) => id === userDetail._id);
    // }
    if (coupon.couponType === CouponType.REGISTERED_SINGLE_USE) {
      return userDetail?.coupons?.some((id) => id === coupon._id);
    }
    // For UNIQUE_SINGLE_USE coupons, check if anyone has used it
    if (coupon.couponType === CouponType.UNIQUE_SINGLE_USE) {
      return coupon.usedBy?.length > 0;
    }
    return false;
  };

  const isCouponExpired = (validTo) => {
    return new Date(validTo) < new Date();
  };

  const isCouponNotStarted = (validFrom) => {
    return new Date(validFrom) > new Date();
  };

  const isCouponActive = (coupon) => {
    const now = new Date();
    return (
      coupon.isActive &&
      new Date(coupon.validFrom) <= now &&
      new Date(coupon.validTo) >= now &&
      !isCouponUsed(coupon)
      // &&
      // coupon.numberOfUse - coupon.usedBy.length > 0 // Check if uses are remaining
    );
  };

  const handleCouponClick = async (coupon) => {
    if (!isCouponActive(coupon)) return;

    navigator.clipboard.writeText(coupon.coupenCode);
    toast.success(`Coupon code ${coupon.coupenCode} copied to clipboard!`);
  };

  const renderCouponSection = (coupons, title, description) => {
    // Filter out expired coupons
    const validCoupons = coupons.filter((coupon) => {
      const isExpired = new Date(coupon.validTo) < new Date();
      // if (coupon.couponType !== CouponType.PUBLIC_MULTI_USE) {
      //   const noUsesLeft = coupon.numberOfUse - coupon.usedBy.length <= 0;
      //   return !isExpired && !noUsesLeft;
      // }
      return !isExpired;
    });

    // Don't render section if no valid coupons
    if (validCoupons.length === 0) {
      return (
        <h2
          style={{
            color: "#3c3260",
            marginBottom: "30px",
            fontSize: "2rem",
            textAlign: "center",
          }}
        >
          No coupons available
        </h2>
      );
    }

    return (
      <>
        <h2
          style={{
            color: "#3c3260",
            marginBottom: "30px",
            fontSize: "2rem",
            textAlign: "center",
          }}
        >
          {title}
        </h2>
        <p
          style={{
            color: "#666",
            marginBottom: "40px",
            textAlign: "center",
            fontSize: "1.1rem",
          }}
        >
          {description}
        </p>
        <div className="row justify-content-center g-4">
          {coupons.map((coupon) => {
            const isUsed = isCouponUsed(coupon);
            const isNotStarted = isCouponNotStarted(coupon.validFrom);
            const isActive = isCouponActive(coupon);
            const requiresLogin =
              !token && coupon.couponType === CouponType.REGISTERED_SINGLE_USE;

            return (
              <div key={coupon._id} className="col-lg-4 col-md-6 col-sm-12">
                <div
                  className="coupon-card"
                  style={{
                    background:
                      isUsed || isNotStarted || requiresLogin
                        ? "#f5f5f5"
                        : "white",
                    borderRadius: "15px",
                    padding: "25px",
                    height: "100%",
                    minHeight: "250px",
                    transition: "all 0.3s ease",
                    boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
                    opacity: isUsed || isNotStarted || requiresLogin ? 0.7 : 1,
                    position: "relative",
                    overflow: "hidden",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    cursor: isActive ? "pointer" : "default",
                  }}
                  onClick={() => isActive && handleCouponClick(coupon)}
                >
                  <div className="d-flex justify-content-between align-items-start">
                    <div>
                      <h3 style={{ color: "#3c3260", marginBottom: "10px" }}>
                        {coupon.discount}% OFF
                      </h3>
                      <h5 style={{ color: "#333", marginBottom: "15px" }}>
                        {coupon.couponName}
                      </h5>
                      <p
                        style={{
                          fontSize: "0.9rem",
                          color: "#666",
                          marginBottom: "10px",
                        }}
                      >
                        {coupon.description}
                      </p>
                      <div
                        style={{
                          padding: "5px 10px",
                          background: "#3c3260",
                          color: "white",
                          borderRadius: "5px",
                          display: "inline-block",
                          fontSize: "0.9rem",
                          position: "relative",
                          marginBottom: "15px",
                        }}
                      >
                        Code: {coupon.coupenCode}
                        {isActive && (
                          <div
                            style={{
                              position: "absolute",
                              bottom: "-25px",
                              left: "0",
                              width: "140%",
                              fontSize: "0.7rem",
                              color: "#3c3260",
                              fontStyle: "italic",
                              padding: "5px",
                            }}
                          >
                            Click to copy coupon code
                          </div>
                        )}
                      </div>
                    </div>
                    <img
                      src={coupon.coupenImage}
                      alt={coupon.couponName}
                      style={{
                        width: "80px",
                        height: "80px",
                        objectFit: "cover",
                        borderRadius: "10px",
                      }}
                    />
                  </div>

                  <div
                    style={{
                      marginTop: "15px",
                      paddingTop: "15px",
                      borderTop: "1px dashed #ddd",
                      fontSize: "0.8rem",
                      color: "#888",
                    }}
                  >
                    <div className="d-flex justify-content-between">
                      <span>
                        Valid From:{" "}
                        {new Date(coupon.validFrom).toLocaleDateString()}
                      </span>
                      <span>
                        Valid Till:{" "}
                        {new Date(coupon.validTo).toLocaleDateString()}
                      </span>
                    </div>
                  </div>

                  {(isUsed || isNotStarted || requiresLogin) && (
                    <div
                      style={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%) rotate(-45deg)",
                        background: "#ff000066",
                        padding: "5px 20px",
                        color: "white",
                        width: "200%",
                        textAlign: "center",
                        textTransform: "uppercase",
                        fontSize: "1.2rem",
                        fontWeight: "bold",
                      }}
                    >
                      {isUsed
                        ? "Already Used"
                        : isNotStarted
                        ? "Not Started"
                        : requiresLogin
                        ? "Login to use"
                        : "Coupon Not Active"}
                    </div>
                  )}

                  {coupon.couponType === CouponType.REGISTERED_SINGLE_USE &&
                    !token && (
                      <div
                        style={{
                          position: "absolute",
                          top: "10px",
                          right: "10px",
                          background: "#3c3260",
                          color: "white",
                          padding: "3px 8px",
                          borderRadius: "3px",
                          fontSize: "0.7rem",
                        }}
                      >
                        Registered Users Only
                      </div>
                    )}
                </div>
              </div>
            );
          })}
        </div>
      </>
    );
  };

  return (
    <>
      <section
        className="hero-section"
        style={{
          background: "#3c3260",
          padding: "60px 0",
          marginTop: "100px",
        }}
      >
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8 col-md-12 col-sm-12">
              <div style={{ textAlign: "center" }}>
                <h1
                  style={{
                    fontSize: "3.5rem",
                    marginBottom: "20px",
                    color: "white",
                  }}
                >
                  Available Coupons
                </h1>
                <p
                  style={{
                    fontSize: "1.2rem",
                    marginBottom: "30px",
                    color: "white",
                  }}
                >
                  Save more with our exclusive discount coupons
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="coupons-sec" style={{ padding: "60px 0" }}>
        <div className="container">
          {loading ? (
            <div className="text-center">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : (
            <>
              {userCoupons.length > 0 &&
                renderCouponSection(
                  userCoupons,
                  "Your Special Offers",
                  "Exclusive discounts just for you"
                )}
            </>
          )}
        </div>
      </section>
    </>
  );
};

export default Coupons;
